import { render, staticRenderFns } from "./strategy-chart-header.component.vue?vue&type=template&id=4fe63882"
import script from "./strategy-chart-header.component.vue?vue&type=script&lang=js"
export * from "./strategy-chart-header.component.vue?vue&type=script&lang=js"
import style0 from "./strategy-chart-header.component.vue?vue&type=style&index=0&id=4fe63882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports